export const getData = async (id) =>
    await fetch(`/docs/alert-preferences/${id}/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });

export const updateData = async (id, data) =>
    await fetch(`/docs/alert-preferences/${id}/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
